import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner = ({ 
  size = 'md', 
  className 
}) => {
  const sizes = {
    sm: 20,
    md: 40,
    lg: 60,
  }

  return (
    <CircularProgress 
      size={sizes[size]}
      className={className}
    />
  )
}

export const LoadingPage = ({ 
  message = 'Loading...' 
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: 256, 
      gap: 2 
    }}>
      <LoadingSpinner size="lg" />
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
    </Box>
  )
}

export const LoadingOverlay = ({ 
  isVisible, 
  message = 'Loading...' 
}) => {
  if (!isVisible) return null

  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <Box sx={{
        backgroundColor: 'white',
        borderRadius: 2,
        padding: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2
      }}>
        <LoadingSpinner size="lg" />
        <Typography variant="body1" color="text.primary">
          {message}
        </Typography>
      </Box>
    </Box>
  )
}

export default LoadingSpinner
